// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type OrganisationDetailQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type OrganisationDetailQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & OrganisationDetailFragment
    )> }
  )> }
);

export type OrganisationPatchMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.OrganisationInputType;
}>;


export type OrganisationPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'OrganisationModelAsAdminQueries' }
        & OrganisationDetailFragment
      )> }
    )> }
  )> }
);

export type SendersQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type SendersQuery = (
  { __typename?: 'Query' }
  & { organisation: (
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PrivateSchemaTypes.OrganisationModelGqlBase, 'id'>
    & { emailIdentities: Array<(
      { __typename?: 'EmailIdentityModel' }
      & Pick<PrivateSchemaTypes.EmailIdentityModel, 'id' | 'email' | 'name' | 'verified_at' | 'order'>
    )> }
  ) }
);

export type EditableSendersQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type EditableSendersQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id'>
      & { emailIdentities: Array<(
        { __typename?: 'EmailIdentityAsAdminModel' }
        & EmailIdentityFragment
      )> }
    )> }
  )> }
);

export type PatchSenderMutationVariables = PrivateSchemaTypes.Exact<{
  input: PrivateSchemaTypes.OrganisationEmailIdentityInputType;
}>;


export type PatchSenderMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { setEmailIdentity?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EmailIdentityAsAdminModel' }
        & EmailIdentityFragment
      )> }
    )> }
  )> }
);

export type ResendSenderMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ResendSenderMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { emailIdentity?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EmailIdentityAsAdminModel' }
        & Pick<PrivateSchemaTypes.EmailIdentityAsAdminModel, 'sendVerificationEmail'>
      )> }
    )> }
  )> }
);

export type RevertSenderMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type RevertSenderMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.OrganisationModelAsAdminMutations, 'id'>
      & { emailIdentity?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EmailIdentityAsAdminModel' }
        & { revert?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityAsAdminModel' }
          & EmailIdentityFragment
        )> }
      )> }
    )> }
  )> }
);

export type EmailIdentityFragment = (
  { __typename?: 'EmailIdentityAsAdminModel' }
  & Pick<PrivateSchemaTypes.EmailIdentityAsAdminModel, 'id' | 'previous_email_identity_id' | 'email' | 'name' | 'verified_at' | 'order'>
);

export type OrganisationDetailFragment = (
  { __typename?: 'OrganisationModelAsAdminQueries' }
  & Pick<PrivateSchemaTypes.OrganisationModelAsAdminQueries, 'id' | 'name' | 'default_user_locale' | 'timezone' | 'domain_lock' | 'email_comments' | 'email_content' | 'session_expiry' | 'allow_signup' | 'ip_whitelist' | 'domainWhitelistBreaches' | 'can_students_update_profile' | 'only_sso_login' | 'notifications'>
  & { subdomain?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'SubdomainModel' }
    & Pick<PrivateSchemaTypes.SubdomainModel, 'name'>
  )>, oauthConfigs: Array<(
    { __typename?: 'OauthConfigModel' }
    & Pick<PrivateSchemaTypes.OauthConfigModel, 'provider' | 'enabled'>
  )>, features: (
    { __typename?: 'OrganisationFeatures' }
    & Pick<PrivateSchemaTypes.OrganisationFeatures, 'custom_i18n'>
    & { cpd?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CPDData' }
      & Pick<PrivateSchemaTypes.CpdData, 'enabled' | 'switched_on'>
    )>, hotjar?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'HotjarSetup' }
      & Pick<PrivateSchemaTypes.HotjarSetup, 'enabled' | 'site_id'>
    )>, link_unfurling?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'LinkUnfurlingData' }
      & Pick<PrivateSchemaTypes.LinkUnfurlingData, 'enabled' | 'switched_on'>
    )> }
  ), g_suite?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'OrganisationGSuite' }
    & Pick<PrivateSchemaTypes.OrganisationGSuite, 'calendar' | 'drive' | 'driveServiceAccount' | 'linkedResourcesDriveId'>
  )>, styles: (
    { __typename?: 'OrganisationStyles' }
    & Pick<PrivateSchemaTypes.OrganisationStyles, 'logo' | 'colors'>
  ), embed_domains?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'EmbedDomains' }
    & Pick<PrivateSchemaTypes.EmbedDomains, 'enabled' | 'domains'>
  )>, calendars: (
    { __typename?: 'OrganisationCalendars' }
    & { google?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'GoogleCalendarConfigPublic' }
      & Pick<PrivateSchemaTypes.GoogleCalendarConfigPublic, 'calendarId'>
    )> }
  ) }
);

export const EmailIdentityFragmentDoc = gql`
    fragment emailIdentity on EmailIdentityAsAdminModel {
  id
  previous_email_identity_id
  email
  name
  verified_at
  order
}
    `;
export const OrganisationDetailFragmentDoc = gql`
    fragment organisationDetail on OrganisationModelAsAdminQueries {
  id
  name
  default_user_locale
  timezone
  domain_lock
  email_comments
  email_content
  session_expiry
  allow_signup
  ip_whitelist
  domainWhitelistBreaches
  can_students_update_profile
  only_sso_login
  subdomain {
    name
  }
  oauthConfigs {
    provider
    enabled
  }
  features {
    cpd {
      enabled
      switched_on
    }
    hotjar {
      enabled
      site_id
    }
    link_unfurling {
      enabled
      switched_on
    }
    custom_i18n
  }
  notifications
  g_suite {
    calendar
    drive
    driveServiceAccount
    linkedResourcesDriveId
  }
  styles {
    logo
    colors
  }
  embed_domains {
    enabled
    domains
  }
  calendars {
    google {
      calendarId
    }
  }
}
    `;
export const OrganisationDetailDocument = gql`
    query organisationDetail {
  admin {
    organisation {
      ...organisationDetail
    }
  }
}
    ${OrganisationDetailFragmentDoc}`;

/**
 * __useOrganisationDetailQuery__
 *
 * To run a query within a React component, call `useOrganisationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationDetailQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationDetailQuery, OrganisationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationDetailQuery, OrganisationDetailQueryVariables>(OrganisationDetailDocument, options);
      }
export function useOrganisationDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationDetailQuery, OrganisationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationDetailQuery, OrganisationDetailQueryVariables>(OrganisationDetailDocument, options);
        }
export type OrganisationDetailQueryHookResult = ReturnType<typeof useOrganisationDetailQuery>;
export type OrganisationDetailLazyQueryHookResult = ReturnType<typeof useOrganisationDetailLazyQuery>;
export type OrganisationDetailQueryResult = Apollo.QueryResult<OrganisationDetailQuery, OrganisationDetailQueryVariables>;
export const OrganisationPatchDocument = gql`
    mutation organisationPatch($input: OrganisationInputType!) {
  admin {
    organisation {
      id
      patch(input: $input) {
        ...organisationDetail
      }
    }
  }
}
    ${OrganisationDetailFragmentDoc}`;
export type OrganisationPatchMutationFn = Apollo.MutationFunction<OrganisationPatchMutation, OrganisationPatchMutationVariables>;

/**
 * __useOrganisationPatchMutation__
 *
 * To run a mutation, you first call `useOrganisationPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPatchMutation, { data, loading, error }] = useOrganisationPatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationPatchMutation, OrganisationPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationPatchMutation, OrganisationPatchMutationVariables>(OrganisationPatchDocument, options);
      }
export type OrganisationPatchMutationHookResult = ReturnType<typeof useOrganisationPatchMutation>;
export type OrganisationPatchMutationResult = Apollo.MutationResult<OrganisationPatchMutation>;
export type OrganisationPatchMutationOptions = Apollo.BaseMutationOptions<OrganisationPatchMutation, OrganisationPatchMutationVariables>;
export const SendersDocument = gql`
    query senders {
  organisation {
    id
    emailIdentities {
      id
      email
      name
      verified_at
      order
    }
  }
}
    `;

/**
 * __useSendersQuery__
 *
 * To run a query within a React component, call `useSendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSendersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SendersQuery, SendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SendersQuery, SendersQueryVariables>(SendersDocument, options);
      }
export function useSendersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SendersQuery, SendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SendersQuery, SendersQueryVariables>(SendersDocument, options);
        }
export type SendersQueryHookResult = ReturnType<typeof useSendersQuery>;
export type SendersLazyQueryHookResult = ReturnType<typeof useSendersLazyQuery>;
export type SendersQueryResult = Apollo.QueryResult<SendersQuery, SendersQueryVariables>;
export const EditableSendersDocument = gql`
    query editableSenders {
  admin {
    organisation {
      id
      emailIdentities: editableEmailIdentities {
        ...emailIdentity
      }
    }
  }
}
    ${EmailIdentityFragmentDoc}`;

/**
 * __useEditableSendersQuery__
 *
 * To run a query within a React component, call `useEditableSendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableSendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableSendersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditableSendersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EditableSendersQuery, EditableSendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditableSendersQuery, EditableSendersQueryVariables>(EditableSendersDocument, options);
      }
export function useEditableSendersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditableSendersQuery, EditableSendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditableSendersQuery, EditableSendersQueryVariables>(EditableSendersDocument, options);
        }
export type EditableSendersQueryHookResult = ReturnType<typeof useEditableSendersQuery>;
export type EditableSendersLazyQueryHookResult = ReturnType<typeof useEditableSendersLazyQuery>;
export type EditableSendersQueryResult = Apollo.QueryResult<EditableSendersQuery, EditableSendersQueryVariables>;
export const PatchSenderDocument = gql`
    mutation patchSender($input: OrganisationEmailIdentityInputType!) {
  admin {
    organisation {
      id
      setEmailIdentity(input: $input) {
        ...emailIdentity
      }
    }
  }
}
    ${EmailIdentityFragmentDoc}`;
export type PatchSenderMutationFn = Apollo.MutationFunction<PatchSenderMutation, PatchSenderMutationVariables>;

/**
 * __usePatchSenderMutation__
 *
 * To run a mutation, you first call `usePatchSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchSenderMutation, { data, loading, error }] = usePatchSenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchSenderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchSenderMutation, PatchSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchSenderMutation, PatchSenderMutationVariables>(PatchSenderDocument, options);
      }
export type PatchSenderMutationHookResult = ReturnType<typeof usePatchSenderMutation>;
export type PatchSenderMutationResult = Apollo.MutationResult<PatchSenderMutation>;
export type PatchSenderMutationOptions = Apollo.BaseMutationOptions<PatchSenderMutation, PatchSenderMutationVariables>;
export const ResendSenderDocument = gql`
    mutation resendSender($id: PositiveInt!) {
  admin {
    organisation {
      id
      emailIdentity(id: $id) {
        sendVerificationEmail
      }
    }
  }
}
    `;
export type ResendSenderMutationFn = Apollo.MutationFunction<ResendSenderMutation, ResendSenderMutationVariables>;

/**
 * __useResendSenderMutation__
 *
 * To run a mutation, you first call `useResendSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSenderMutation, { data, loading, error }] = useResendSenderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendSenderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendSenderMutation, ResendSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendSenderMutation, ResendSenderMutationVariables>(ResendSenderDocument, options);
      }
export type ResendSenderMutationHookResult = ReturnType<typeof useResendSenderMutation>;
export type ResendSenderMutationResult = Apollo.MutationResult<ResendSenderMutation>;
export type ResendSenderMutationOptions = Apollo.BaseMutationOptions<ResendSenderMutation, ResendSenderMutationVariables>;
export const RevertSenderDocument = gql`
    mutation revertSender($id: PositiveInt!) {
  admin {
    organisation {
      id
      emailIdentity(id: $id) {
        revert {
          ...emailIdentity
        }
      }
    }
  }
}
    ${EmailIdentityFragmentDoc}`;
export type RevertSenderMutationFn = Apollo.MutationFunction<RevertSenderMutation, RevertSenderMutationVariables>;

/**
 * __useRevertSenderMutation__
 *
 * To run a mutation, you first call `useRevertSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertSenderMutation, { data, loading, error }] = useRevertSenderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevertSenderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevertSenderMutation, RevertSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevertSenderMutation, RevertSenderMutationVariables>(RevertSenderDocument, options);
      }
export type RevertSenderMutationHookResult = ReturnType<typeof useRevertSenderMutation>;
export type RevertSenderMutationResult = Apollo.MutationResult<RevertSenderMutation>;
export type RevertSenderMutationOptions = Apollo.BaseMutationOptions<RevertSenderMutation, RevertSenderMutationVariables>;